import Link from "next/link"
import React from "react"

export const HeadingTitle = ({ title, children, href, to }) => {
  const Title = () => (
    <>
      {href && to && (
        <h1 className="mb-1">
          <Link
            href={href}
            as={to}
            className="text-black fw-600 fs-32px fs-mobile-28px lh-36px d-block"
            style={{ marginLeft: "-3px" }}>
            {title}
          </Link>
        </h1>
      )}
      {!href && !to && (
        <h1 className="text-black mb-1 fw-600" style={{ marginLeft: "-3px" }}>
          {title}
        </h1>
      )}
      {children && children !== "" && (
        <div className="color-black font-secondary fs-15px fs-mobile-14px pb-lg-1 mb-0">
          {children}
        </div>
      )}
    </>
  )

  return <Title />
}
